import React, { useEffect, useRef } from 'react';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import LogoutPopup from 'apps/auth/components/profile/LogoutPopup';
import {
    COMPLETE_PROFILE_CONTINUE_CLICKED,
    COMPLETE_PROFILE_NOT_NOW_CLICKED,
    COMPLETE_PROFILE_PROMO_SHOWN,
} from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { SDD } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const TellUsAboutYourself = (props) => {
    const {
        promoTellAboutYourselfPurpleTitle,
        promoTellAboutYourselfGrayTitle,
        promoTellAboutYourselfMainUpText,
        promoTellAboutYourselfMainDownText,
        continueButton,
        notNow,
    } = usePageMessages();
    const { registrationStep_1_optional } = useExtra();
    const popupRef = useRef(null);

    useEffect(() => {
        sendEvent(COMPLETE_PROFILE_PROMO_SHOWN);
    }, []);

    const sendEvent = (eventName) => {
        amplitude.getInstance().logEvent(eventName);
    };

    return (
        <BaseLayout>
            <InfoPage
                iconName="paysend-logo-globe"
                iconColor="primary"
                topButtonCaption={notNow}
                topButtonOnClick={(e) => {
                    sendEvent(COMPLETE_PROFILE_NOT_NOW_CLICKED);
                    if (!registrationStep_1_optional) {
                        e?.preventDefault();
                        popupRef?.current?.open(<LogoutPopup popupRef={popupRef} fromFlow={SDD} />);
                    } else {
                        window.location.href = AUTH_SEND_MAIN_LINK;
                    }
                }}
                topButtonLink={AUTH_SEND_MAIN_LINK}
                headerText={
                    <>
                        <span>{promoTellAboutYourselfPurpleTitle}</span>
                        {promoTellAboutYourselfGrayTitle}
                    </>
                }
                secondaryText={
                    <>
                        <p>{promoTellAboutYourselfMainUpText}</p>
                        <p>{promoTellAboutYourselfMainDownText}</p>
                    </>
                }
                primaryButtonCaption={continueButton}
                primaryButtonOnClick={() => {
                    sendEvent(COMPLETE_PROFILE_CONTINUE_CLICKED);
                    props.onContinueClick();
                }}
            />
            <PopupNew ref={popupRef} />
        </BaseLayout>
    );
};
TellUsAboutYourself.propTypes = {
    onContinueClick: PropTypes.func.isRequired,
};
export default TellUsAboutYourself;
